import axios from '../utils/axios';
import { baseURL } from '../utils/axios';

export const getSubjects = async () => {
  const response = await axios.get('/subjects');
  return response.data;
};

export const getSubjectContent = async (schoolId, subjectId) => {
  const response = await axios.get(`/schools/${schoolId}/courses/${subjectId}`);
  return response.data;
};

export const getSchools = async () => {
  const response = await axios.get('/schools');
  return response.data;
};

export const getSingleSchool = async (id) => {
  const response = await axios.get(`/schools/${id}`);
  return response.data;
};

//create content
export const getSubjectClasses = async (id) => {
  const response = await axios.get(`/schools/${id}/subject-classes`);
  return response.data;
};

export const getCourses = async (id) => {
  const response = await axios.get(`/teachers/${id}/courses`);
  return response.data;
};

export const createLesson = async (id, data) => {
  const response = await axios.post(`/schools/${id}/courses`, data);
  return response.data;
};

export const updateCourse = async (teacherId, lessonId, data) => {
  const response = await axios.put(
    `/teachers/${teacherId}/courses/${lessonId}`,
    data
  );
  return response.data;
};

export const updateLesson = async (
  schoolId,
  courseId,
  topicId,
  lessonId,
  data
) => {
  const response = await axios.put(
    `/schools/${schoolId}/courses/${courseId}/topics/${topicId}/lessons/${lessonId}`,
    data
  );
  return response.data;
};

export const createTopic = async (schoolId, courseId, data) => {
  const response = await axios.post(
    `schools/${schoolId}/courses/${courseId}/topics`,
    data
  );
  return response.data;
};

export const updateTopic = async (schoolId, courseId, topicId, data) => {
  const response = await axios.put(
    `schools/${schoolId}/courses/${courseId}/topics/${topicId}`,
    data
  );
  return response.data;
};

export const createUnitLesson = async (schoolId, courseId, topicId, data) => {
  const response = await axios.post(
    `schools/${schoolId}/courses/${courseId}/topics/${topicId}/lessons`,
    data
  );
  return response.data;
};

export const publishCourse = async () => {
  let teacher = JSON.parse(localStorage.getItem('userData'));
  let course = JSON.parse(localStorage.getItem('course'));
  const response = await axios.put(
    `teachers/${teacher.id}/courses/${course.id}/publish`,
    {}
  );
  return response.data;
};

export const deleteCourse = async (id) => {
  let teacher = JSON.parse(localStorage.getItem('userData'));
  const response = await axios.delete(
    `teachers/${teacher.id}/courses/${id}`,
    {}
  );
  return response.data;
};

export const deleteContent = async (courseId, topicId, lessonId, contentId) => {
  let teacher = JSON.parse(localStorage.getItem('userData'));
  const response = await axios.delete(
    `teachers/${teacher.id}/courses/${courseId}/topics/${topicId}/lessons/${lessonId}/contents/${contentId}`,
    {}
  );
  return response.data;
};

export const publishTopic = async () => {
  let teacher = JSON.parse(localStorage.getItem('userData'));
  let topic = JSON.parse(localStorage.getItem('topic'));
  const response = await axios.put(
    `teachers/${teacher.id}/topics/${topic.id}/publish`,
    {}
  );
  return response.data;
};

export const getTeacherCourses = async () => {
  let teacher = JSON.parse(localStorage.getItem('userData'));
  const response = await axios.get(`teachers/${teacher.id}/courses`);
  return response.data;
};

export const getTeacherTopics = async () => {
  let teacher = JSON.parse(localStorage.getItem('userData'));
  const response = await axios.get(`teachers/${teacher.id}/topics`);
  return response.data;
};

export const getTopic = async (token, studentId, courseId, topicId) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
  };
  const response = await axios.get(
    `students/${studentId}/courses/${courseId}/topics/${topicId}`,
    config
  );
  return response.data;
};
